import React, { useState } from 'react';
import { MessageSquareIcon } from 'lucide-react';
import { Note } from '../types';
import { Textarea } from './ui/Textarea';
import { Button } from './ui/Button';
export interface OrderNotesProps {
  notes: Note[];
  onAddNote: (content: string) => void;
}
export function OrderNotes({
  notes,
  onAddNote
}: OrderNotesProps) {
  const [newNote, setNewNote] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newNote.trim()) return;
    setIsSubmitting(true);
    await onAddNote(newNote);
    setNewNote('');
    setIsSubmitting(false);
  };
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };
  const sortedNotes = [...notes].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  return <div className="space-y-6" data-id="element-252">
      <form onSubmit={handleSubmit} className="bg-slate-50 border border-slate-200 rounded-lg p-4" data-id="element-253">
        <Textarea placeholder="Add a note or comment..." value={newNote} onChange={e => setNewNote(e.target.value)} rows={3} className="mb-3" data-id="element-254" />
        <div className="flex justify-end" data-id="element-255">
          <Button type="submit" variant="primary" disabled={!newNote.trim() || isSubmitting} data-id="element-256">
            Add Note
          </Button>
        </div>
      </form>

      {sortedNotes.length === 0 ? <div className="text-center py-12 bg-slate-50 rounded-lg border border-slate-200" data-id="element-257">
          <MessageSquareIcon className="w-12 h-12 mx-auto text-slate-400 mb-3" data-id="element-258" />
          <p className="text-slate-600" data-id="element-259">No notes yet</p>
        </div> : <div className="space-y-4" data-id="element-260">
          {sortedNotes.map(note => <div key={note.id} className="bg-white border border-slate-200 rounded-lg p-4" data-id="element-261">
              <div className="flex items-center justify-between mb-2" data-id="element-262">
                <span className="text-sm font-medium text-slate-900" data-id="element-263">
                  {note.author}
                </span>
                <span className="text-xs text-slate-500" data-id="element-264">
                  {formatDate(note.createdAt)}
                </span>
              </div>
              <p className="text-sm text-slate-700 whitespace-pre-wrap" data-id="element-265">
                {note.content}
              </p>
            </div>)}
        </div>}
    </div>;
}